(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d2rbc-homepage-promotions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function todayString() {
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return now.getFullYear() + '-' + month + '-' + day;
    }

    function storageGet(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function storageSet(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    }

    function initPopup(popup) {
      if (!popup || popup.dataset.d2rbcPromoInitialized === 'true') {
        return;
      }

      popup.dataset.d2rbcPromoInitialized = 'true';

      var storageKey = popup.getAttribute('data-storage-key') || 'd2rbc_homepage_promo_popup_last_shown';
      var delay = parseInt(popup.getAttribute('data-popup-delay'), 10);
      var dialog = popup.querySelector('.d2rbc-promo-popup__dialog');
      var closeButtons = popup.querySelectorAll('[data-close-popup]');
      var popupLinks = popup.querySelectorAll('[data-popup-link]');
      var previouslyFocused = null;
      var today = todayString();

      if (storageGet(storageKey) === today) {
        return;
      }

      if (Number.isNaN(delay) || delay < 0) {
        delay = 0;
      }

      function markShown() {
        storageSet(storageKey, todayString());
      }

      function openPopup() {
        previouslyFocused = document.activeElement;
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('d2rbc-promo-popup-open');

        if (dialog) {
          dialog.focus({ preventScroll: true });
        }
      }

      function closePopup() {
        markShown();
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('d2rbc-promo-popup-open');

        if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
          previouslyFocused.focus({ preventScroll: true });
        }
      }

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closePopup);
      });

      popupLinks.forEach(function (link) {
        link.addEventListener('click', markShown);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      });

      window.setTimeout(openPopup, delay);
    }

    function initPromotions(container) {
      var scope = container || document;
      scope.querySelectorAll('[data-d2rbc-promo-popup]').forEach(initPopup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initPromotions(document);
      });
    } else {
      initPromotions(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initPromotions(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
